module.exports = __webpack_public_path__ + "img/male_blurred_std_avatar.c39c61a6.jpg";